import './SectionSeam.css';

export function SectionSeamDown() {
  return (
    <div className="SectionSeam" aria-hidden="true">
      <div className="SectionSeam-tear-down" />
    </div>
  );
}

export function SectionSeamUp() {
  return (
    <div className="SectionSeam" aria-hidden="true">
      <div className="SectionSeam-tear-up" />
    </div>
  );
}


